<template>
  <Transition name="promo-pill-fade" :duration="{ enter: 260, leave: 120 }">
    <button
      v-if="!bookingOptionsInView"
      type="button"
      class="promo-pill fixed left-[14px] bottom-4 z-[1010] flex items-center gap-2 rounded-full border border-[color-mix(in_srgb,var(--white)_10%,transparent)] bg-[#0d0d0f]/95 px-4 py-2.5 shadow-[0_10px_28px_rgba(0,0,0,0.4)] backdrop-blur-2xl transition-[border-color,transform] duration-150 ease-out hover:border-[#ff6a2e]/50 active:scale-95"
      :class="{ 'promo-pill--raised': raised }"
      aria-label="Show promo code"
      @click="emit('expand')"
    >
      <span class="flex size-[22px] shrink-0 items-center justify-center rounded-full bg-[#ff6a2e]/15">
        <icon-promo-chevron-right class="text-[12px] text-[#ff6a2e]" />
      </span>
      <span class="font-anton text-[13px] font-normal tracking-[0.4px] text-white">
        {{ label }}
      </span>
    </button>
  </Transition>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ label: string; raised?: boolean }>(), {
  raised: false,
});
const emit = defineEmits<{ expand: [] }>();
// hides while the product page's Booking Options section is in view (stays
// false, i.e. always visible, on any page without that section)
const bookingOptionsInView = useBookingOptionsInView();
</script>

<style scoped>
.promo-pill {
  animation: promo-pill-pop-in 260ms cubic-bezier(0.16, 1, 0.3, 1) both;
}
.promo-pill-fade-enter-active {
  transition: opacity 150ms ease-out;
}
.promo-pill-fade-leave-active {
  transition: opacity 120ms ease-in;
}
.promo-pill-fade-enter-from,
.promo-pill-fade-leave-to {
  opacity: 0;
}
/* lifts the pill above a mobile sticky bottom bar (e.g. product page's
   check-availability CTA) so the two don't overlap; no-op on desktop */
.promo-pill--raised {
  bottom: calc(90px + env(safe-area-inset-bottom));
}
@media (min-width: 768px) {
  .promo-pill--raised {
    bottom: 1rem;
  }
}
.font-anton {
  font-family: "Anton", Impact, sans-serif;
}
@keyframes promo-pill-pop-in {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .promo-pill {
    animation-duration: 1ms;
  }
}
</style>
